import React from 'react';
import ReactDOM from 'react-dom';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { RecoilRoot } from 'recoil';
import { ThemeProvider } from '@mui/material/styles';
import { CookiesProvider } from 'react-cookie';
import App from './App';
import theme from './theme';

const init = async () => {
  ReactDOM.render(
    <CookiesProvider>
      <RecoilRoot>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </RecoilRoot>
    </CookiesProvider>,
    document.querySelector('#root')
  );
};

init();
